import { combineReducers } from 'redux';
import session from './session/session.reducer';
import addressForm from './addressInformationForm/addressForm.reducer';
import cart from './cart/cart.reducer';
import checkout from './checkout/checkout.reducer';
import platformParams from './platformParams/platformParams.reducer';

export default combineReducers({ session, cart, checkout, platformParams, addressForm });
